module.exports = __webpack_public_path__ + "static/media/Bicocca - GR GREEN - 7972_7526_7411_7414.8e1047fb.jpg";